<template>
 <LiefengTable
     :talbeColumns="talbeColumns"
      :tableData="tableData"
        :total="total"
        :curPage="page"
        @hadlePageSize="hadlePageSize"
        :pagesizeOpts="[10, 20, 30, 50]"
        :loading="loading"
        :fixTable="true"
        :pageSize="pageSize"
  ></LiefengTable>
</template>

<script>
import LiefengTable from "@/components/LiefengTable";
export default {
  props: ["info"],
  data() {
    return {
      talbeColumns: [
        {
          title: "回访情况",
          key: "content",
          minWidth: 150,
          align: "center",
        },
        {
          title: "回访人",
          key: "visitName",
          minWidth: 150,
          align: "center",
        },
        {
          title: "回访日期",
          key: "visitDate",
          minWidth: 180,
          align: "center",
        },
        {
          title: "创建时间",
          key: "gmtCreate",
          minWidth: 180,
          align: "center",
        },
      ],
       tableData: [],
      page: 1,
      loading: false,
      pageSize: 20,
      total: 0
    };
  },
  methods: {
    hadlePageSize(obj) {
      this.loading = true;
      this.$post('/archives/api/pc/referralVisit/queryVisitByArchiveIdPage',{
        archiveId: this.info,
        page: obj.page,
        pageSize: obj.pageSize
      }).then(res => {
        if(res.code == 200 && res.data.referralVisitPages.code == 200 && res.data.referralVisitPages.dataList) {
          res.data.referralVisitPages.dataList.map(item => {
            if(item.gmtCreate) {
              item.gmtCreate = this.$core.formatDate(new Date(item.gmtCreate),"yyyy-MM-dd")
            }
            if(item.visitDate) {
             item.visitDate =  this.$core.formatDate(new Date(item.visitDate),"yyyy-MM-dd")
            }
          })
          this.tableData = res.data.referralVisitPages.dataList;
          this.page = res.data.referralVisitPages.currentPage;
          this.total = res.data.referralVisitPages.maxCount;
          this.pageSize = res.data.referralVisitPages.pageSize;
           this.loading = false;
        }else {
          this.$Message.error({
            background: true,
            content: res.desc
          })
        }
      })
    }
  },
  created() {
      this.hadlePageSize({
        page: this.page,
        pageSize: this.pageSize
      })
  },
  components: {
    LiefengTable,
  },
};
</script>
    
<style scoped lang='less'>
</style>